import React, {useCallback, useEffect, useState} from 'react';
import cx from 'classnames';
import {FieldLabel, FieldWrapper, InputFeedback} from '../index';
import {useInputFocus} from '../hooks';
import {useDebouncedCallback} from 'use-debounce';

export const Textarea = ( {
                              id,
                              name,
                              label,
                              labelAppend,
                              hint,
                              error,
                              errorShown,
                              tooltip,
                              value,
                              isFocused,
                              onChange,
                              onBlur,
                              className,
                              labelClassName,
                              inputClassName,
                              children,
                              debounceOnChange=true,
                              ...props
                          } ) => {

    const [innerValue, setInnerValue] = useState( value );

    useEffect( () => {
        if ( value ) {
            setInnerValue( value );
        }
        else {
            setInnerValue( '' );
        }
    }, [value] );

    const debouncedHandleOnChange = useDebouncedCallback(
        ( event ) => onChange( event ),
        200
    );

    const handleOnChange = useCallback( ( event ) => {
        event.persist();

        const newValue = event.currentTarget.value;
        setInnerValue( newValue );
        if ( onChange ) {
            debounceOnChange ? debouncedHandleOnChange( event ) : onChange( event );
        }
    }, [] );

    const {fieldRef} = useInputFocus( isFocused );

    const groupClasses = cx(
        'w-full textarea-group',
        className,
        {
            'animated shake error': !!error || !!errorShown
        }
    );

    const inputClasses = cx(
        'textarea block w-full',
        {'disabled': props.disabled},
        inputClassName
    );

    return (
        <div className={groupClasses}>
            <FieldLabel
                label={label}
                append={labelAppend}
                tooltip={tooltip}
                id={id}
                hint={hint}
                error={error}
                className={labelClassName}
            />
            <FieldWrapper
                tabIndex={0}
                component="textarea"
                innerRef={fieldRef}
                id={id}
                name={name || id}
                className={inputClasses}
                onBlur={onBlur}
                onChange={handleOnChange}
                value={innerValue}
                {...props}>
                {children}
            </FieldWrapper>
            <InputFeedback error={error}/>
        </div>
    );
}
